import { EventStore } from 'app/event/service/event.store';
import { Page } from './../../../shared/models/page';
import { Component, Input, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Rsvp } from '../../models/rsvp';
import { StaySummary } from '../../models/stay-summary';
import { RsvpStore } from '../../service/rsvp.store';
import { PagesizeType } from '../../service/pagination/pagesize-type';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';

@Component({
  selector: 'pioneer-payment-rsvp',
  templateUrl: './payment-rsvp.component.html'
})
export class PaymentRsvpComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public rsvpsPage: Page<Rsvp>;
  public staySummary: StaySummary;

  pagesizeType = PagesizeType.PAYMENT_RSVP;

  constructor(private rsvpStore: RsvpStore,
    private eventStore: EventStore,
    private userLocalStorageService: UserLocalStorageService) {
  }

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit() {
    this.goToRecordsPage(0);
    this.eventStore.getStaySummary(this.onyxEvent)
    .map(staySummary => this.staySummary = staySummary)
      .take(1)
      .subscribe();
  }

  getCommission(rsvp: Rsvp): number {
    let commission: number;
    if (rsvp) {
      let revenue = rsvp.revenue;
      if (!revenue) {
        revenue = this.getRevenue(rsvp);
      }
      commission = (revenue * this.onyxEvent.commissionRoomPercentage) / 100;
    } else {
      commission = undefined;
    }
    return commission;
  }

  getCommissionFromStaySummary(staySummary: StaySummary): number {
    return staySummary ? staySummary.totalRevenue * this.onyxEvent.commissionRoomPercentage / 100 : undefined;
  }

  goToRecordsPage(pageNumber: number) {
    this.rsvpStore.getRsvpsFromEvent(this.onyxEvent.eventId, pageNumber,
      this.userLocalStorageService.getPagesize(PagesizeType.PAYMENT_RSVP))
      .map(page => this.rsvpsPage = page )
      .take(1)
      .subscribe();
  }

  private getRevenue(rsvp: Rsvp): number {
    return rsvp ? rsvp.nights * rsvp.roomRate : undefined;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/rsvp/payment-rsvp.component.ts